import { TemplateResult, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzSingleSelectListWebComponent } from '../../gzSingleSelectList/component/GzSingleSelectListWebComponent';
import { desanitizeObject } from 'apps/webcomponents/src/utils/sanitization.utils';
import { ListEvents } from '../../gzSingleSelectList/types';
import { classMap } from 'lit/directives/class-map.js';
import { PhoneNumberItem } from '../types';

@customElement('gz-single-select-list-phone-code')
export class GzSingleSelectListPhoneCodeWebComponent extends GzSingleSelectListWebComponent {
  @property({ type: Array, attribute: true, reflect: true })
  filterOptions: PhoneNumberItem[] = [];

  static get styles() {
    return styles;
  }

  protected renderFilterOptionsList(): TemplateResult {
    return html`${this.filterOptions.map(option => this.renderOption(option))}`;
  }

  private renderOption(option: PhoneNumberItem): TemplateResult {
    option = desanitizeObject(option);

    const classes = {
      'option-item': true,
      'fs-12': true,
      'option-selectable': true,
      active: `${this.getActiveOptionClass(option)}`,
      hidden: option.hidden ?? false,
    };

    return html`
      <div
        ?disabled="${option.disabled}"
        class="${classMap(classes)}"
        @click="${e => this.handleOptionChange(option, e)}"
      >
        <span class="country-code"> ${option.countryCode} </span>
        <gz-tooltip tooltiptext="${option.country}" isellipsis="true" class="tooltip">
          <span> ${option.country} </span>
        </gz-tooltip>
        <span class="phone-code">${option.label} </span>
      </div>
    `;
  }

  protected getFilteredResults(searchString: string): PhoneNumberItem[] {
    if (searchString.trim().startsWith(' ')) {
      return [];
    }

    const lowerCaseSearchString = searchString.toLowerCase();

    return this.filterOptions.filter((option: PhoneNumberItem) => {
      return (
        option.country.toLowerCase().includes(lowerCaseSearchString) ||
        option.label.toLowerCase().includes(lowerCaseSearchString) ||
        option.countryCode.toLowerCase().includes(lowerCaseSearchString)
      );
    });
  }

  protected handleOptionChange(option: PhoneNumberItem, e: CustomEvent) {
    this.selectedOption = option;
    this.clearSearchInput(e);
    if (!this.selectionEventEmitted) {
      this.emitConfirmSelectionEvent();
      this.selectionEventEmitted = true;
    }
  }

  public emitConfirmSelectionEvent(): void {
    const event = new CustomEvent(ListEvents.SELECTION_CHANGE, {
      detail: {
        selectedValue: this._selectedOption ? this._selectedOption.value : null,
        selectedLabel: this._selectedOption ? this._selectedOption.label : null,
      },
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-single-select-list-phone-code': GzSingleSelectListPhoneCodeWebComponent;
  }
}
